// extracted by mini-css-extract-plugin
export default {"survey_title":"index_survey_title_DYARd clearfix","count_box":"index_count_box_4-J05","count":"index_count_kRMn3","logo":"index_logo_GXF9R","img":"index_img_0FETF"};